/** biome-ignore-all lint/suspicious/noExplicitAny: allow any data to be sent */
export function sendTrackingData(event: string, data: any) {
  try {
    const formData = new FormData();

    for (const key in data) {
      if (
        typeof Object.hasOwn === 'function' ? Object.hasOwn(data, key) : Object.hasOwn(data, key)
      ) {
        const value = data[key];
        if (value !== undefined && value !== null) {
          formData.append(key, typeof value === 'object' ? JSON.stringify(value) : String(value));
        }
      }
    }

    const csrfToken = evite.cookie('csrftoken');
    if (csrfToken) {
      formData.append('csrfmiddlewaretoken', csrfToken);
    } else {
      evite.error('CSRF token missing');
      return;
    }

    if (!navigator.sendBeacon(`/services/tracking/v1/${event}/ingest/`, formData)) {
      evite.error('Failed to send upsell tracking beacon', formData);
    }
  } catch (e) {
    evite.error('Failed to send upsell track', e);
  }
}

export function getHeaderType(isHomepage: boolean, isAtTop: boolean) {
  if (isHomepage && !isAtTop) return 'jumbotron';
  if (isHomepage && isAtTop) return 'header';
  if (!isHomepage && !isAtTop) return 'header_with_banner';
  return 'header'; // default if both false
}
